import React, { ReactElement } from 'react';
import ChampMultiple, { affichageElementDefaut } from '../../Common/ChampMultiple';
import { ArrayHelpers } from 'formik';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { PopoutEntite } from '../Utils/PopoutEntite';
import CreerClient from './CreerClient';
import { Client } from '../../../../../common/src/entities';
import PopoverSimple from '../../Common/PopoverSimple';
import { BiAt, BiCheckCircle, BiNote, BiPhone, BiUser, BiXCircle } from 'react-icons/bi';
import { CopierPressePapier } from '../Utils/CopierPressePapier';
import { cssTexte } from '../constantes';
import { DateTime } from 'luxon';
import TooltipSimple from '../../Common/TooltipSimple';
import { FaHashtag } from 'react-icons/fa';
import DynamicTableParametreReservation from './DynamicTableParametreReservation';

function AffichageTexte(props: { value: Client }): ReactElement {
    const {
        value: { fin_abonnement, courriel, telephone, notes },
    } = props;
    
    const telephoneIcon = (
        <CopierPressePapier texte={telephone}>
            <PopoverSimple texte={telephone} titre="Téléphone">
                <BiPhone />
            </PopoverSimple>
        </CopierPressePapier>
    );

    const emailIcon = (
        <CopierPressePapier texte={courriel}>
            <PopoverSimple texte={courriel} titre="Courriel">
                <BiAt />
            </PopoverSimple>
        </CopierPressePapier>
    );

    const estAbonneIcon =
        DateTime.fromISO(fin_abonnement) > DateTime.local() ? (
            <TooltipSimple inList texte="Abonné">
                <BiCheckCircle color="green" />
            </TooltipSimple>
        ) : (
            <TooltipSimple inList texte="Non-abonné">
                <BiXCircle color="red" />
            </TooltipSimple>
        );

    const parametreReservation = (
        <PopoverSimple
            inList
            texte={
                <>
                    <DynamicTableParametreReservation title={'Paramètres de réservation'} data={props.value} />
                </>
            }
        >
            <u>
                <FaHashtag />
            </u>
        </PopoverSimple>
    );

    const notesWithBreaks = notes.split('\n').map((line, index) => <div key={index}>{line}</div>);

    const notesInternesIcon = (
        <CopierPressePapier texte={notes}>
            <PopoverSimple texte={notesWithBreaks} titre="Notes">
                <BiNote />
            </PopoverSimple>
        </CopierPressePapier>
    );

    return (
        <div style={cssTexte}>
            <span>
                {telephoneIcon} {emailIcon} {estAbonneIcon} {parametreReservation} {notesInternesIcon}
            </span>
        </div>
    );
}

function AffichageAjoutClient(props: {
    helpers: ArrayHelpers;
    values: Client[];
    title?: string;
    maxSize?: number;
    avecUnBouton?: boolean;
}): ReactElement {
    const bsAlert = useAlertDialog();
    return (
        <PopoutEntite
            affichageOption={(c: Client) => (
                <>
                    {c.prefix} {c.name}{' '}
                    {c.centre_service_scolaire && c.centre_service_scolaire.name && (
                        <>
                            (<i>{c.centre_service_scolaire.name}</i>)
                        </>
                    )}
                </>
            )}
            titre={`Ajouter un ${props.title?.toLowerCase() ?? 'client'}`}
            entite={Client}
            isCreatable
            modalSize="lg"
            modalBody={(props) => <CreerClient {...props} />}
            size="sm"
            disabled={props.maxSize === props.values.length ? true : false}
            onChange={(value) => {
                const client = value as Client;
                if (client) {
                    if (props.values?.find((item) => item.id === client.id)) {
                        bsAlert('Ce client est déjà associé!', 'warning');
                    } else if (props.maxSize && props.values.length === props.maxSize) {
                        bsAlert(`Vous ne pouvez qu'ajouter un max de ${props.maxSize} élément(s)`, 'warning');
                    } else {
                        props.helpers.unshift(value);
                    }
                }
            }}
            avecUnBouton={props.avecUnBouton}
        />
    );
}

function affichageClient(client: Client) {
    return (
        <>
            <div style={cssTexte}>
                {client.prefix} {client.name}{' '}
                {client.centre_service_scolaire && client.centre_service_scolaire.abbr && (
                    <>
                        (<i>{client.centre_service_scolaire.abbr}</i>)
                    </>
                )}
            </div>
            <div>
                <AffichageTexte value={client} />
            </div>
        </>
    );
}

const affichageAjoutClient = (values, helpers, maxSize?: number, title?: string, avecUnBouton?: boolean) => (
    <AffichageAjoutClient
        helpers={helpers}
        values={values}
        maxSize={maxSize}
        title={title}
        avecUnBouton={avecUnBouton}
    />
);

interface PropsChampMultipleClient {
    id: string;
    maxSize?: number;
    title?: string;
    labelCol?: number;
    estPetit?: boolean;
    avecUnBouton?: boolean;
}

export default function ChampMultipleClient(props: PropsChampMultipleClient): ReactElement {
    return (
        <ChampMultiple
            entite={Client}
            titre={`${props.title ?? 'Client'}`}
            {...props}
            affichageAjout={affichageAjoutClient}
            affichageTexte={(client: Client | number) => affichageClient(client as Client)}
            affichageElement={affichageElementDefaut(Client)}
        />
    );
}
